<template>
    <div>
        <Dialog v-bind:value="value" @input="$emit('input', $event)"
                :title="selectedItem && !addOnly? 'Targeting bearbeiten' : 'Targeting anlegen'"
                :loading="loading"
                @click:outside="close"
                @ok="submit"
                @cancel="close"
        >
            <template v-slot:button v-if="selectedItem && !addOnly">
                <Button :text="true" :color="ada.red" v-if="!$store.state.readOnly"
                        @click="showDeleteDialog = true">
                    Löschen
                </Button>
            </template>
            <v-row>
                <v-col cols="12">
                    <Input v-model.trim="name" label="Name"
                           :error-messages="name_errors" :required="true"
                           @input="$v.name.$touch()"
                           @blur="$v.name.$touch()"
                           @enter="submit"></Input>
                </v-col>
            </v-row>
        </Dialog>
        <DeleteTargetingDialog v-model="showDeleteDialog" @deleted="close"></DeleteTargetingDialog>
    </div>
</template>

<script>
import Dialog from "../../../components/Dialog";
import Input from "../../../components/Inputs/Input";
import Button from "../../../components/buttons/Button";
import ada from "../../../scss/ada_colors.scss";
import DeleteTargetingDialog from "./DeleteTargetingDialog";
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";
import Utils from "../../../scripts/Utils";

export default {
    name: "AddEditTargetingDialog",
    props: {
        value: {},
        addOnly: { //Neded for the dialog to not use the property selectedItem in AddEditPublisherDialog.vue
            type: Boolean,
            default: false,
        }
    },
    components: {DeleteTargetingDialog, Button, Input, Dialog},
    mixins: [validationMixin],
    validations() {
        return {
            name: {required},
        }
    },
    data: () => {
        return {
            name: null,
            loading: false,
            showDeleteDialog: false,
            ada
        }
    },
    mounted() {
        this.init();
    },
    computed: {
        selectedItem() {
            return this.$store.state.settings.selectedItem;
        },
        name_errors() {
            return Utils.handleError(this, 'name', 'Name ist erforderlich.');
        },
        validate() {
            return this.name_errors.length === 0;
        },
        errorCount() {
            return this.$store.state.errorCount;
        }
    },
    methods: {
        init() {
            if (this.selectedItem && !this.addOnly) {
                this.name = this.selectedItem.Name;
            } else {
                this.name = null;
            }
        }
        ,
        async submit() {
            this.$v.$touch();
            if (this.validate) {
                this.loading = true;
                try {
                    let data = await this.$store.dispatch('settings/editTargeting', this.getBody());
                    this.loading = false;
                    if (data.Status) {
                        let msg = this.selectedItem && !this.addOnly ? 'Erfolgreich gespeichert.' : 'Targeting erfolgreich angelegt.';
                        this.$root.$emit('snackbar', msg);
                        this.close();
                    }
                } catch (e) {
                    this.loading = false;
                }
            }
        },
        getBody() {
            let json = {
                name: this.name,
            };
            if (this.selectedItem && !this.addOnly) json.targeting_id = this.selectedItem.TargetingId;
            return json;
        },
        close() {
            if (!this.addOnly) this.$store.commit('settings/resetSelected');
            this.init();
            this.$emit('input', false); // set v-model to false -> close dialog
        },
    }
    ,
    watch: {
        selectedItem() {
            if (this.$store.state.settings.activeTab === 'Settings_Targetings') this.init();
        },
        errorCount() {
            this.loading = false;
        }
    }
}
</script>

<style lang="scss" scoped>
</style>